import React, { useState, useEffect } from "react";
import Container from "./styles";
import { useLocation } from "react-router-dom";
import {getOrderByTrackingNo, getSingleBike} from '../../../../store/actions'
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

const OrderView = () => {
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const { state: query } = useLocation();
  
  const { tracker } = useSelector((s) => s.UserData);

  useEffect(()=>{
    dispatch(getOrderByTrackingNo({"tracking_number":query?.state?.reference}))
    dispatch(getSingleBike(query?.state?.bike_id))
  },[])

  return (
    <Container>
      <div className="Orders_Details">
        <svg
          width="26"
          height="21"
          viewBox="0 0 26 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5284 4.58852L3.60055 11.9247C3.60054 11.935 3.59791 11.9503 3.59266 11.9711C3.58752 11.9917 3.58478 12.0067 3.58476 12.0173L3.57285 19.4604C3.57242 19.7291 3.67029 19.9622 3.86643 20.1586C4.06251 20.3552 4.29492 20.4543 4.56371 20.4547L10.518 20.4643L10.5275 14.5096L14.4976 14.516L14.4881 20.4708L20.4423 20.4804C20.7111 20.4808 20.9441 20.3826 21.1405 20.1863C21.3373 19.9907 21.4363 19.7578 21.4367 19.489L21.4486 12.0459C21.4487 12.0047 21.4431 11.9735 21.4331 11.9532L12.5284 4.58852Z"
            fill="white"
            fill-opacity="0.5"
          />
          <path
            d="M24.8462 10.2838L21.455 7.45614L21.4651 1.12941C21.4653 0.98478 21.419 0.865761 21.3259 0.772519C21.2335 0.679388 21.1146 0.632706 20.9696 0.632473L17.9924 0.627707C17.8476 0.627475 17.7287 0.673776 17.6354 0.766611C17.5423 0.859554 17.4957 0.978479 17.4954 1.12306L17.4906 4.14681L13.7121 0.97731C13.3821 0.707987 12.9894 0.572988 12.5345 0.572259C12.0797 0.571531 11.6866 0.705272 11.3554 0.973536L0.190973 10.2443C0.0874836 10.3267 0.0306577 10.4377 0.0198976 10.5773C0.00919197 10.7168 0.0451148 10.8386 0.127776 10.9421L1.08733 12.0911C1.17 12.1842 1.27832 12.2413 1.41271 12.2623C1.5368 12.2729 1.66096 12.2368 1.7852 12.1544L12.5299 3.22397L23.2462 12.1887C23.3289 12.2609 23.4372 12.2971 23.5716 12.2973L23.6182 12.2974C23.7525 12.2772 23.8608 12.2201 23.9442 12.1275L24.9075 10.9817C24.9903 10.8783 25.0268 10.7568 25.0162 10.6171C25.0059 10.4779 24.9492 10.3667 24.8462 10.2838Z"
            fill="white"
            fill-opacity="0.5"
          />
        </svg>
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginLeft: 10 }}
        >
          <path
            d="M0.0680001 0.909999H2.598L7.922 5.948L2.598 11.008H0.0680001L5.392 5.948L0.0680001 0.909999Z"
            fill="white"
            fill-opacity="0.6"
          />
        </svg>
        <div style={{ color: "#fff", marginLeft: 10 }}>
          {query?.state?.reference}
        </div>
      </div>
      <div className="order__viewContainer">
        <div>
          <div className="order_box">
            <div>Pick up Information</div>
            <div className="name">City</div>
            <div className="details">{query?.state.drop_off_city}</div>
            <div className="name">Address</div>
            <div className="details">{query?.state.drop_off_address}</div>
            <div className="name">Phone Number</div>
            <div className="details">{query?.state.recipient_phone_number}</div>
          </div>

          <div className="order_box">
            <div>Drop off Information</div>
            <div className="name">City</div>
            <div className="details">{query?.state.pick_up_city}</div>
            <div className="name">Address</div>
            <div className="details">{query?.state.pick_up_address}</div>
            <div className="name">Phone Number</div>
            <div className="details">{query?.state.pick_up_phone_number}</div>
          </div>
        </div>
        <div style={{ marginLeft: 10, marginRight: 10 }}>
          <div
            className="order_box"
            style={{
              width: "100%",
              padding: 0,
              paddingTop: 20,
              paddingBottom: 20
            }}
          >
            <table>
              <thead
                style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.2)" }}
              >
                <tr>
                  <th
                    style={{ width: 300, textAlign: "start", paddingLeft: 10 }}
                  >
                    Description
                  </th>
                  <th
                    style={{ width: 260, textAlign: "start", paddingLeft: 10 }}
                  >
                    weight
                  </th>
                  <th
                    style={{ width: 260, textAlign: "start", paddingLeft: 10 }}
                  >
                    Priority
                  </th>
                  <th
                    style={{ width: 260, textAlign: "start", paddingLeft: 10 }}
                  >
                    Subtotal
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: 10 }}>{query?.state.description}</td>
                  <td style={{ padding: 10 }}>{query?.state.weight}</td>
                  <td style={{ padding: 10 }}>
                    {query?.state.delivery_priority == "3"
                      ? "high"
                      : query?.state.delivery_priority == "2"
                      ? "middle"
                      : "low"}
                  </td>
                  <td style={{ padding: 10 }}>{query?.state.amount}</td>
                </tr>
              </tbody>
            </table>
            <div style={{display: "flex", justifyContent:"end"}}>
              <table style={{ width: 100 , marginTop:105}}>
                <thead
                  
                >
                  <tr>
                    <th
                      style={{
                        width: 260,
                        textAlign: "start",
                        paddingLeft: 10
                      }}
                    >
                     
                    </th>
                    <th
                      style={{
                        width: 260,
                        textAlign: "start",
                        paddingLeft: 10
                      }}
                    >
                      total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ padding: 10 }}>Subtotal</td>
                    <td style={{ padding: 10 }}>{query?.state.amount}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: 10 }}>Priotity cost({query?.state.delivery_priority == "3"
                      ? "high"
                      : query?.state.delivery_priority == "2"
                      ? "middle"
                      : "low"})</td>
                    <td style={{ padding: 10 }}>{query?.state.delivery_priority == "3"
                      ? "1000"
                      : "0"}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: 10 }}>Subtotal</td>
                    <td style={{ padding: 10 }}>{1000 + JSON.parse(query?.state.amount)  }</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div>
          <div className="order_box">
          <div>
            <div style={{marginBottom:10}}>Order Progress</div>
           {/* { tracker?.order_status.map((dataStatus)=>(
          <div style={{display:"flex"}}>
            <img src="/mark2.png"  style={{height:100, marginRight:10}} alt="mark image"/>
            <div style={{marginRight:10}}>
            <div className="details" style={{color: "#fff"}}>{dataStatus.notes}</div>

            <div className="details" style={{fontSize:12}}>{dataStatus.status}</div>
            </div>
            <div style={{width:80, textAlign:"end"}}>

            <div className="details" style={{color: "#fff"}}>Just Now</div>

            <div className="details" style={{fontSize:12}}>{moment(dataStatus.created_at).format("MMM Do YY")}</div>
            </div>
          </div>
           ))}   */}
          </div>
          </div>

          <div className="order_box">
            <div>Status update</div>

            <div
              className="details"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: 20,
                fontWeight: "700"
              }}
            >
              <div
                style={
                  query?.state.status == "fulfilled"
                    ? { color: "green" }
                    : query?.state.status == "pending"
                    ? { color: "yellow" }
                    : { color: "red" }
                }
              >
                {query?.state.status}
              </div>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_406_1864)">
                  <path
                    d="M15.8333 10.0383C15.3725 10.0383 15 10.4117 15 10.8716V17.5383C15 17.9974 14.6266 18.3716 14.1667 18.3716H2.5C2.03995 18.3716 1.66672 17.9974 1.66672 17.5383V5.87158C1.66672 5.41245 2.03995 5.0383 2.5 5.0383H9.16672C9.62753 5.0383 10 4.66492 10 4.20502C10 3.74496 9.62753 3.37158 9.16672 3.37158H2.5C1.12167 3.37158 0 4.49326 0 5.87158V17.5383C0 18.9166 1.12167 20.0383 2.5 20.0383H14.1667C15.545 20.0383 16.6667 18.9166 16.6667 17.5383V10.8716C16.6667 10.4108 16.2941 10.0383 15.8333 10.0383Z"
                    fill="white"
                    fill-opacity="0.7"
                  />
                  <path
                    d="M7.81393 9.27936C7.75564 9.33765 7.71642 9.4118 7.69979 9.49176L7.11065 12.4385C7.08318 12.5751 7.12652 12.7159 7.22479 12.8151C7.30398 12.8943 7.41064 12.9367 7.51989 12.9367C7.54644 12.9367 7.57406 12.9343 7.60153 12.9285L10.5474 12.3394C10.629 12.3226 10.7032 12.2835 10.7607 12.2251L17.354 5.63174L14.4082 2.68604L7.81393 9.27936Z"
                    fill="white"
                    fill-opacity="0.7"
                  />
                  <path
                    d="M19.3911 0.64846C18.5787 -0.16407 17.257 -0.16407 16.4453 0.64846L15.292 1.80172L18.2379 4.74758L19.3911 3.59417C19.7845 3.20171 20.0012 2.67834 20.0012 2.1217C20.0012 1.56506 19.7845 1.04168 19.3911 0.64846Z"
                    fill="white"
                    fill-opacity="0.7"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_406_1864">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>

          <div className="order_box">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              Bike Assigned
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.2755 5.70005L15.6008 5.6671L14.3901 1.7482C14.1833 1.08656 13.5875 0.620353 12.8963 0.586603L10.7571 0.48214L10.6768 2.12769L12.816 2.23216L13.8565 5.58193L9.89896 5.38867L9.64294 4.55143L10.5562 4.59602L10.6366 2.95047L6.52269 2.74958L6.44234 4.39513L7.8822 4.46544L9.17876 8.65245L8.6275 8.62553C8.35507 6.77306 6.88278 5.34035 4.9619 5.15583C2.66375 4.92814 0.554327 6.74677 0.441828 9.05055C0.329328 11.3543 2.05105 13.2528 4.35482 13.3653C6.37885 13.4642 8.08408 12.1536 8.54714 10.2711L12.0028 10.4398C12.2752 12.2923 13.7475 13.725 15.6684 13.9095C17.967 14.129 20.076 12.3186 20.1889 10.0066C20.301 7.71105 18.5793 5.81255 16.2755 5.70005ZM6.83577 10.1875C6.45965 11.1341 5.52947 11.7732 4.43518 11.7198C3.05291 11.6523 2.01988 10.5132 2.08738 9.1309C2.15488 7.74864 3.29398 6.71561 4.67625 6.78311C5.77054 6.83654 6.63402 7.56324 6.91612 8.54196L4.59589 8.42866L4.51553 10.0742L6.83577 10.1875ZM12.0832 8.79428L10.9313 8.73803L10.411 7.06315L12.904 7.18489C12.5187 7.64442 12.2285 8.18283 12.0832 8.79428ZM15.9541 12.2823C14.5718 12.2148 13.5388 11.0757 13.6063 9.6934C13.6436 8.92822 14.0131 8.28647 14.5618 7.85966L15.2456 10.0704L16.8197 9.58641L16.1289 7.35062C16.1454 7.35142 16.1704 7.3444 16.1951 7.3456C17.5774 7.4131 18.6104 8.5522 18.5429 9.93447C18.4754 11.3167 17.3363 12.3498 15.9541 12.2823Z"
                  fill="white"
                  fill-opacity="0.8"
                />
                <path
                  d="M9.17071 16.0748L5.8796 15.9141L10.6957 18.6235L10.7761 16.978L14.0672 17.1387L9.25107 14.4293L9.17071 16.0748Z"
                  fill="white"
                  fill-opacity="0.8"
                />
              </svg>
            </div>
            <div
              className="details"
              style={{
                marginTop: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              Shittu Ayomide
              <div
                style={{
                  marginTop: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}
              >
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: 5 }}
                >
                  <circle cx="5.5" cy="5.5" r="5.5" fill="white" />
                  <g clip-path="url(#clip0_812_1251)">
                    <path
                      d="M7.26717 6.39859C6.95049 6.12774 6.62911 5.96367 6.31631 6.23412L6.12954 6.39757C5.99288 6.51622 5.7388 7.07062 4.75644 5.94055C3.77429 4.81192 4.35875 4.63619 4.49561 4.51856L4.68341 4.35491C4.99457 4.08385 4.87714 3.74262 4.65272 3.39137L4.5173 3.17861C4.29186 2.82818 4.04637 2.59803 3.7344 2.86868L3.56583 3.01597C3.42794 3.11642 3.04253 3.44292 2.94904 4.06318C2.83652 4.80742 3.19146 5.65967 4.00464 6.59478C4.81679 7.53029 5.61197 8.0002 6.36521 7.99201C6.9912 7.98526 7.36925 7.64935 7.48749 7.52722L7.65668 7.37973C7.96783 7.10928 7.77451 6.83392 7.45763 6.56246L7.26717 6.39859Z"
                      fill="#FF7B0D"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_812_1251">
                      <rect
                        width="5.24219"
                        height="5.24219"
                        fill="white"
                        transform="translate(2.75 2.75)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                07014537629
              </div>
            </div>
            <div
              className="name"
              style={{
                marginTop: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              City
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default OrderView;

